import type { TemplateDef } from "./types";

// 配信風テンプレート定義（初回セットは横型のみ）。
// 実在配信プラットフォームのロゴ・アイコン・固有の配色を使わないこと
// （テンプレート追加時のレビュー項目。要件の受け入れ条件）。
const FONT = "'Noto Sans JP', 'Hiragino Sans', 'Yu Gothic', sans-serif";

export const WATERMARK_TEXT = "gokko.live";

export const templates: TemplateDef[] = [
  {
    id: "live-dark",
    name: "ゲーム配信風（ダーク）",
    width: 1280,
    height: 720,
    backdropFill: "#101418",
    decors: [
      // 下部の情報帯
      { kind: "rect", rect: { x: 0, y: 620, width: 1280, height: 100 }, fill: "#1c232b" },
      // LIVE バッジ（オリジナル配色）
      {
        kind: "rect",
        rect: { x: 24, y: 20, width: 92, height: 40 },
        fill: "#e0483e",
        cornerRadius: 6,
      },
      {
        kind: "text",
        rect: { x: 24, y: 28, width: 92, height: 28 },
        text: "LIVE",
        fontFamily: FONT,
        fontSize: 24,
        fill: "#ffffff",
        align: "center",
      },
    ],
    imageSlots: {
      main: { frame: { x: 0, y: 0, width: 1280, height: 620 } },
      facecam: {
        frame: { x: 968, y: 356, width: 288, height: 240 },
        cornerRadius: 12,
        borderColor: "#37d4ae",
        borderWidth: 5,
      },
    },
    textSlots: {
      viewers: {
        frame: { x: 128, y: 26, width: 300, height: 32 },
        fontFamily: FONT,
        fontSize: 26,
        fill: "#ffffff",
        stroke: "#101418",
        strokeWidth: 4,
        align: "left",
        maxLength: 12,
      },
      telop: {
        frame: { x: 24, y: 636, width: 1232, height: 68 },
        fontFamily: FONT,
        fontSize: 52,
        fill: "#ffe14d",
        stroke: "#101418",
        strokeWidth: 8,
        fontStyle: "bold",
        align: "left",
        maxLength: 40,
      },
    },
    initialTexts: { viewers: 12345, telop: "初見プレイ" },
    watermark: {
      text: WATERMARK_TEXT,
      fontFamily: FONT,
      fontSize: 22,
      fill: "#ffffff",
      opacity: 0.7,
      paddingX: 16,
      paddingY: 12,
    },
  },
  {
    id: "live-light",
    name: "ゲーム配信風（ライト）",
    width: 1280,
    height: 720,
    backdropFill: "#f2f4f7",
    decors: [
      { kind: "rect", rect: { x: 0, y: 0, width: 1280, height: 84 }, fill: "#ffffff" },
      {
        kind: "rect",
        rect: { x: 24, y: 22, width: 92, height: 40 },
        fill: "#2f7de1",
        cornerRadius: 20,
      },
      {
        kind: "text",
        rect: { x: 24, y: 30, width: 92, height: 28 },
        text: "配信中",
        fontFamily: FONT,
        fontSize: 20,
        fill: "#ffffff",
        align: "center",
      },
    ],
    imageSlots: {
      main: { frame: { x: 0, y: 84, width: 1280, height: 636 } },
      facecam: {
        frame: { x: 24, y: 456, width: 288, height: 240 },
        cornerRadius: 120,
        borderColor: "#ffffff",
        borderWidth: 6,
      },
    },
    textSlots: {
      viewers: {
        frame: { x: 132, y: 28, width: 300, height: 30 },
        fontFamily: FONT,
        fontSize: 24,
        fill: "#30343a",
        align: "left",
        maxLength: 12,
      },
      telop: {
        frame: { x: 340, y: 500, width: 916, height: 72 },
        fontFamily: FONT,
        fontSize: 56,
        fill: "#ffffff",
        stroke: "#2f7de1",
        strokeWidth: 10,
        fontStyle: "bold",
        align: "right",
        maxLength: 40,
      },
    },
    initialTexts: { viewers: 8888, telop: "神回きたw" },
    watermark: {
      text: WATERMARK_TEXT,
      fontFamily: FONT,
      fontSize: 22,
      fill: "#30343a",
      opacity: 0.6,
      paddingX: 16,
      paddingY: 12,
    },
  },
  {
    id: "live-standee",
    name: "ゲーム配信風（立ち絵・切り抜き向き）",
    width: 1280,
    height: 720,
    backdropFill: "#101418",
    decors: [
      { kind: "rect", rect: { x: 0, y: 620, width: 1280, height: 100 }, fill: "#1c232b" },
      {
        kind: "rect",
        rect: { x: 24, y: 20, width: 92, height: 40 },
        fill: "#e0483e",
        cornerRadius: 6,
      },
      {
        kind: "text",
        rect: { x: 24, y: 28, width: 92, height: 28 },
        text: "LIVE",
        fontFamily: FONT,
        fontSize: 24,
        fill: "#ffffff",
        align: "center",
      },
    ],
    imageSlots: {
      main: { frame: { x: 0, y: 0, width: 1280, height: 620 } },
      // 立ち絵方式: 枠なしで切り抜きキャラを直接重ね、白グローで縁取る。
      // 切り抜きなし（矩形素材）の場合はワイプ型テンプレートの方が向く
      facecam: {
        frame: { x: 860, y: 100, width: 400, height: 560 },
        display: "cutout",
        glowColor: "#ffffff",
        glowBlur: 18,
      },
    },
    textSlots: {
      viewers: {
        frame: { x: 128, y: 26, width: 300, height: 32 },
        fontFamily: FONT,
        fontSize: 26,
        fill: "#ffffff",
        stroke: "#101418",
        strokeWidth: 4,
        align: "left",
        maxLength: 12,
      },
      telop: {
        frame: { x: 24, y: 636, width: 800, height: 68 },
        fontFamily: FONT,
        fontSize: 52,
        fill: "#ffe14d",
        stroke: "#101418",
        strokeWidth: 8,
        fontStyle: "bold",
        align: "left",
        maxLength: 40,
      },
    },
    initialTexts: { viewers: 24680, telop: "本人登場" },
    watermark: {
      text: WATERMARK_TEXT,
      fontFamily: FONT,
      fontSize: 22,
      fill: "#ffffff",
      opacity: 0.7,
      paddingX: 16,
      paddingY: 12,
    },
  },
  {
    id: "live-vertical",
    name: "縦型配信風（スマホ）",
    width: 720,
    height: 1280,
    backdropFill: "#101418",
    decors: [
      // 上部の情報帯（メイン画像に重ねる半透明バー）
      {
        kind: "rect",
        rect: { x: 0, y: 0, width: 720, height: 92 },
        fill: "#101418",
        opacity: 0.72,
      },
      // 下部のテロップ帯
      {
        kind: "rect",
        rect: { x: 0, y: 1088, width: 720, height: 192 },
        fill: "#101418",
        opacity: 0.72,
      },
      // LIVE バッジ（オリジナル配色）
      {
        kind: "rect",
        rect: { x: 16, y: 24, width: 84, height: 40 },
        fill: "#e0483e",
        cornerRadius: 6,
      },
      {
        kind: "text",
        rect: { x: 16, y: 32, width: 84, height: 28 },
        text: "LIVE",
        fontFamily: FONT,
        fontSize: 22,
        fill: "#ffffff",
        align: "center",
      },
    ],
    imageSlots: {
      main: { frame: { x: 0, y: 0, width: 720, height: 1280 } },
      facecam: {
        frame: { x: 528, y: 116, width: 168, height: 168 },
        cornerRadius: 84,
        borderColor: "#37d4ae",
        borderWidth: 5,
      },
    },
    textSlots: {
      viewers: {
        frame: { x: 112, y: 30, width: 280, height: 30 },
        fontFamily: FONT,
        fontSize: 24,
        fill: "#ffffff",
        stroke: "#101418",
        strokeWidth: 4,
        align: "left",
        maxLength: 12,
      },
      telop: {
        frame: { x: 24, y: 1120, width: 672, height: 72 },
        fontFamily: FONT,
        fontSize: 56,
        fill: "#ffe14d",
        stroke: "#101418",
        strokeWidth: 8,
        fontStyle: "bold",
        align: "center",
        maxLength: 40,
      },
    },
    initialTexts: { viewers: 3456, telop: "寝る前にちょっとだけ" },
    watermark: {
      text: WATERMARK_TEXT,
      fontFamily: FONT,
      fontSize: 22,
      fill: "#ffffff",
      opacity: 0.7,
      paddingX: 14,
      paddingY: 10,
    },
  },
  {
    id: "live-vertical-standee",
    name: "縦型配信風（立ち絵・切り抜き向き）",
    width: 720,
    height: 1280,
    backdropFill: "#101418",
    decors: [
      {
        kind: "rect",
        rect: { x: 0, y: 0, width: 720, height: 92 },
        fill: "#101418",
        opacity: 0.72,
      },
      {
        kind: "rect",
        rect: { x: 0, y: 1088, width: 720, height: 192 },
        fill: "#101418",
        opacity: 0.72,
      },
      {
        kind: "rect",
        rect: { x: 16, y: 24, width: 84, height: 40 },
        fill: "#e0483e",
        cornerRadius: 6,
      },
      {
        kind: "text",
        rect: { x: 16, y: 32, width: 84, height: 28 },
        text: "LIVE",
        fontFamily: FONT,
        fontSize: 22,
        fill: "#ffffff",
        align: "center",
      },
    ],
    imageSlots: {
      main: { frame: { x: 0, y: 0, width: 720, height: 1280 } },
      // 立ち絵方式（縦型）: 画面下部中央〜右にキャラクターを大きく重ねる。
      // 下端はテロップ帯に少し掛かり、画面の前に立つ定番レイアウトになる
      facecam: {
        frame: { x: 300, y: 480, width: 400, height: 680 },
        display: "cutout",
        glowColor: "#ffffff",
        glowBlur: 18,
      },
    },
    textSlots: {
      viewers: {
        frame: { x: 112, y: 30, width: 280, height: 30 },
        fontFamily: FONT,
        fontSize: 24,
        fill: "#ffffff",
        stroke: "#101418",
        strokeWidth: 4,
        align: "left",
        maxLength: 12,
      },
      telop: {
        frame: { x: 24, y: 1120, width: 672, height: 72 },
        fontFamily: FONT,
        fontSize: 56,
        fill: "#ffe14d",
        stroke: "#101418",
        strokeWidth: 8,
        fontStyle: "bold",
        align: "center",
        maxLength: 40,
      },
    },
    initialTexts: { viewers: 6789, telop: "急に本人登場" },
    watermark: {
      text: WATERMARK_TEXT,
      fontFamily: FONT,
      fontSize: 22,
      fill: "#ffffff",
      opacity: 0.7,
      paddingX: 14,
      paddingY: 10,
    },
  },
];

export function findTemplate(id: string): TemplateDef | undefined {
  return templates.find((t) => t.id === id);
}
